import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import { PageOops as PageOopsUI } from '@wegic/ui';
import '@wegic/ui/dist/components/PageOops/index.css';
import { useEffect, useRef } from 'react';
import { isOnline } from '@/const/env';
export default function PageOops(param) {
    let { error, errorInfo } = param;
    const hasReportedRef = useRef(false);
    const handleReload = ()=>{
        collect('page_oops_reload_click');
        window.location.reload();
    };
    useEffect(()=>{
        if (!error || hasReportedRef.current) {
            return;
        }
        hasReportedRef.current = true;
        const stack = (error === null || error === void 0 ? void 0 : error.stack) || (errorInfo === null || errorInfo === void 0 ? void 0 : errorInfo.componentStack);
        collect('page_oops', {
            error: (error === null || error === void 0 ? void 0 : error.message) ?? '',
            stack: (stack === null || stack === void 0 ? void 0 : stack.slice(0, 300)) ?? ''
        });
    }, [
        error,
        errorInfo
    ]);
    return /*#__PURE__*/ _jsx(PageOopsUI, {
        error: error,
        errorInfo: errorInfo,
        title: intl.get('page.oops.title'),
        description: /*#__PURE__*/ _jsxs(_Fragment, {
            children: [
                /*#__PURE__*/ _jsx("div", {
                    children: intl.get('page.oops.description')
                }),
                /*#__PURE__*/ _jsx("div", {
                    children: intl.get('page.oops.descriptionContact')
                })
            ]
        }),
        refreshButtonText: intl.get('page.oops.refresh'),
        copyButtonText: intl.get('page.oops.copyError'),
        debugTitle: intl.get('page.oops.devErrorDetail'),
        componentStackTitle: intl.get('page.oops.componentStack'),
        showDebug: !isOnline,
        onReload: handleReload
    });
}
